module.exports = __webpack_public_path__ + "static/media/sx.a7248001.svg";